import {fnLocalizeFilter} from "../../../../../services/localize.service";
import InputPhone from "../../../../UI/Input/InputPhone";
import {useGlobalContext} from "../../../../../services/context.service";
import React, {useEffect, useState} from "react";
import {Button} from "@mui/material";
import {getDataFromLocalStorage} from "../../../../../utils/methods";

interface ISendOTP {
    value: string;

    onChange(e: React.ChangeEvent<HTMLInputElement>): void;

    onSendOTP(): void;
}

export default function SendOTP({value, onChange, onSendOTP}: ISendOTP) {
    const {locale} = useGlobalContext();
    const [phone, setPhone] = useState<string>("");
    const [isEditField, setActiveEditField] = useState(false);

    useEffect(() => {
        if (value !== "") {
            setPhone(value)
        } else {
            const username = getDataFromLocalStorage('username');
            if (username) {
                setPhone(username);
                setActiveEditField(true);
            }
        }
    }, [value]);

    return <><InputPhone
        disabled={isEditField}
        label={fnLocalizeFilter(locale, '_lang.module.register.titlePhone')}
        value={phone}
        onChange={onChange}
        sx={{width: "97%"}}
    />
        <Button
            variant="contained"
            style={{
                width: "100%", marginTop: "1rem", padding: ".7rem 0"
            }}
            onClick={onSendOTP}>
            {fnLocalizeFilter(locale, '_lang.module.register.btnRegisterPhone')}
        </Button>
    </>
}
